var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MonthlyCheckReportHistory',{attrs:{"year":_vm.year,"month":_vm.month,"day":_vm.day,"manager":_vm.manager}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }